<template>
  <div>

    <!-- <div class="elevation-2" style="border-radius: 5px; cursor: pointer;"> -->
    <img :src="frameUrl" class="elevation-2" style="height: 200px; border-radius: 5px; cursor: pointer;" v-on:click="show" />
    <!-- <div class="text-center" style="font-size: 1.5em; font-variant: small-caps;">{{title}}</div> -->
    <!-- </div> -->
    <slot name="description"></slot>
    <modal :name="id" :width="videoWidth" height="auto" class="modal-layout">
      <!-- transition="modal-transition" -->
      <div style="display: flex; flex-flow: column; justify-content: center; align-items: center; background-color: black;">
        <video :width="videoWidth" :height="videoHeight" controls :autoplay="autoplay" style="" :title="title" :alt="title">
          <source :src="videoUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </modal>
  </div>
</template>

<script>
import { randomString } from '@/functions'
export default {
  props: {
    videoFile: null,
    frameFile: null,
    title: null,
    posted: null,
    autoplay: {
      type: Boolean,
      defaut: true
    },
    videoWidth: {
      type: Number,
      default: 1280
    },
    videoHeight: {
      type: Number,
      default: 720
    }
  },
  data() {
    return {
      id: randomString()
    }
  },
  computed: {
    videoUrl() {
      return `http://mes.frazier.com/video/${encodeURIComponent(this.videoFile)}`
    },
    frameUrl() {
      return `http://mes.frazier.com/video/${encodeURIComponent(this.frameFile)}`
    }
  },
  methods: {
    show() {
      this.$modal.show(this.id)
    }
  }
}
</script>

<style>
.modal-layout {
  background-color: rgba(0, 0, 0, 0.75);
  animation: enter 0.4s ease-out;
}

/* .modal-transition-enter-active {
  animation: enter 0.2s ease-out;
}

.modal-transition-leave-active {
  animation: enter 0.4s ease-in reverse;
}

@keyframes enter {
  0% {
    opacity: 0%;
    transform: scale(0.2);
  }
  100% {
    opacity: 100%;
    transform: scale(1);
  }
} */
</style>
